module.exports = __webpack_public_path__ + "static/img/import_error.fba7962d.png";